(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-application-form"] && !Shopify.designMode) return;
  try {
    
  function syncWholesaleShippingFields(form) {
    if (!(form instanceof HTMLElement)) return;

    const shippingFields = form.querySelector('[data-shipping-fields]');
    if (!(shippingFields instanceof HTMLElement)) return;

    const selected = form.querySelector('[data-shipping-same]:checked');
    const showShipping = selected instanceof HTMLInputElement && selected.value === 'No';
    const inputs = shippingFields.querySelectorAll('[data-shipping-input]');

    if (showShipping) {
      shippingFields.hidden = false;
      inputs.forEach((input) => {
        if (input instanceof HTMLInputElement || input instanceof HTMLSelectElement) {
          input.required = true;
        }
      });
      return;
    }

    shippingFields.hidden = true;
    inputs.forEach((input) => {
      if (input instanceof HTMLInputElement) {
        input.required = false;
        input.value = '';
      } else if (input instanceof HTMLSelectElement) {
        input.required = false;
        if (input.name.includes('Country')) {
          input.value = 'United States';
        } else {
          input.selectedIndex = 0;
        }
      }
    });
  }

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!target.matches('[data-shipping-same]')) return;

    const form = target.closest('form');
    syncWholesaleShippingFields(form);
  });

  document.querySelectorAll('form.wholesale-app__form').forEach((form) => {
    syncWholesaleShippingFields(form);
  });

  } catch(e) { console.error(e); }
})();
})();
